export const premiumPickerReferrer = {
  APP_SETTINGS_HOME: 'vod.app-settings.home',
  DASHBOARD_SIDEBAR: 'vod.dashboard.sidebar',
  DASHBOARD_UPLOAD: 'vod.dashboard.upload',
  DASHBOARD_SETTINGS_COUNTER: 'vod.dashboard.settings-counter',
  DASHBOARD_EMAIL_MARKETING_BANNER: 'vod.dashboard.email-marketing.banner',
  DASHBOARD_QUOTA_EXCEEDED_TOOLTIP: 'vod.dashboard.quota-exceeded-tooltip',
  DASHBOARD_VIDEO_INFO: 'vod.dashboard.video-info',
  DASHBOARD_LIBRARY: 'vod.dashboard.video-info',
  DASHBOARD_SETTINGS_EMBED: 'vod.dashboard.setting.embed',
  DASHBOARD_VIDEO_EDIT_EMBED: 'vod.dashboard.video-edit.embed',
  DASHBOARD_CONNECT_STREAM: 'vod.dashboard.live-library.connect-stream'
};
//# sourceMappingURL=package-picker.js.map